var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmployees(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.542969,
    y: 1.01953,
    width: 21.3974,
    height: 21.3974,
    rx: 3.56624,
    fill: "#243677",
    fillOpacity: 0.16
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.364657,
    y: 0.841219,
    width: 21.7541,
    height: 21.7541,
    rx: 3.74455,
    stroke: "#243677",
    strokeOpacity: 0.16,
    strokeWidth: 0.356624
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5104_12269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1882 17.0659V15.8772C17.1882 14.7693 16.4306 13.8385 15.4051 13.5746M13.3248 6.54001C14.1961 6.8927 14.8108 7.74691 14.8108 8.74468C14.8108 9.74245 14.1961 10.5967 13.3248 10.9494M14.2164 17.0659C14.2164 15.9581 14.2164 15.4042 14.0354 14.9673C13.7941 14.3848 13.3313 13.9219 12.7487 13.6806C12.3118 13.4997 11.7579 13.4997 10.6501 13.4997H8.86702C7.75925 13.4997 7.20536 13.4997 6.76845 13.6806C6.18589 13.9219 5.72306 14.3848 5.48176 14.9673C5.30078 15.4042 5.30078 15.9581 5.30078 17.0659M12.1361 8.74468C12.1361 10.0577 11.0716 11.1222 9.75858 11.1222C8.44553 11.1222 7.38109 10.0577 7.38109 8.74468C7.38109 7.43163 8.44553 6.36719 9.75858 6.36719C11.0716 6.36719 12.1361 7.43163 12.1361 8.74468Z",
    stroke: "#243677",
    strokeWidth: 1.4265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5104_12269"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.265,
    height: 14.265,
    fill: "white",
    transform: "translate(4.10938 4.58594)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployees);
export default __webpack_public_path__ + "static/media/employees.b8585c7ebf90e4a11a46af6c97d3cce2.svg";
export { ForwardRef as ReactComponent };